import Http from 'services/Http';
import sanitizeAgenticBody from './sanitizeAgenticBody';

class AgentTagApi {
  list() {
    return Http.get('/v1/tags').then(r => r.data.tags);
  }

  create(body) {
    return Http.post('/v1/tags', sanitizeAgenticBody(body)).then(r => r.data.tag);
  }

  update(id, body) {
    return Http.put(`/v1/tags/${id}`, sanitizeAgenticBody(body)).then(r => r.data.tag);
  }

  reevaluate(id) {
    return Http.post(`/v1/tags/${id}/reevaluate`).then(r => r.data);
  }

  destroy(id) {
    return Http.delete(`/v1/tags/${id}`);
  }
}

export default new AgentTagApi();
